<template>
  <el-form
    :model="form"
    ref="form">
    <el-form-item
      :label="L10n('part-sn')"
      prop="partSN"
      :rules="getValidationRule('required,minLength')"
      class="material-style">
      <el-input
        ref="firstField"
        :value="form.partSN"
        @input="form.partSN = valueTrimLeft($event)"
      />
    </el-form-item>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormStockDuplicate',
  mixins: [Form]
}
</script>
